import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './App'
import {Provider} from "react-redux";
import {store} from "./store/AppStore";
import {App as Application} from 'antd'


const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Application>
    <Provider store={store}>
      <App/>
    </Provider>
  </Application>)
